import type { UserPreferences } from '@src/dto/UserPreferences';
import { hasS3Config } from './s3CredentialManager';
import { isUploadProviderEnabled } from './providerHelpers';
import { getDefaultUploadProvider } from './userPreferences';

export function hasConfiguredStorageProvider(
  preferences: UserPreferences,
): boolean {
  if (!isUploadProviderEnabled(preferences.uploadProvider)) {
    return false;
  }

  if (preferences.uploadProvider === getDefaultUploadProvider()) {
    return true;
  }

  // Non-default providers must be explicitly selected by the user.
  if (!preferences.hasExplicitlySetProvider) {
    return false;
  }

  switch (preferences.uploadProvider) {
    case 's3':
      return hasS3Config();

    case 'ardrive':
      return true;

    default:
      return false;
  }
}
